module.exports = __webpack_public_path__ + "img/maintaining-weight.a456a54a.png";